import { NavigationTarget } from '../api/science/openapi/api';
import { AssistantNavigation } from '../types';

const KNOWN_TARGETS: readonly string[] = Object.values(NavigationTarget);

/** Guards a parsed v4 `navigate` SSE payload; unknown targets (newer backend) are rejected. */
export const isNavigateEvent = (value: unknown): value is AssistantNavigation => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const navigation = value as Record<string, unknown>;
  return (
    typeof navigation.target === 'string' &&
    KNOWN_TARGETS.includes(navigation.target) &&
    typeof navigation.label === 'string' &&
    typeof navigation.auto === 'boolean'
  );
};

/** Parses the raw `navigate` SSE data string; null when malformed or an unknown target. */
export const parseNavigateEvent = (rawData: string): AssistantNavigation | null => {
  try {
    const parsed = JSON.parse(rawData) as unknown;
    return isNavigateEvent(parsed) ? parsed : null;
  } catch {
    return null;
  }
};
